

//this is a child function to useReorientImage. is not meant to be used 
//for anything else

export const changeImageOrientation = ({srcUrl, imageRotate, callback}) => {
    
    var img = new Image();
    img.crossOrigin = "anonymous"; // This enables CORS

    img.src = srcUrl;
    
    img.onload = function () {
        var width = img.width,
        height = img.height,
        canvas = document.createElement("canvas"),
        ctx = canvas.getContext("2d");

        const degToOrientationValueMap = [
          {deg: -0, orientation: 1},  
          {deg: 0, orientation: 1},  
          {deg: -360, orientation: 1},
          {deg: 90, orientation: 6}, 
          {deg: -270, orientation: 6},
          {deg: 180, orientation: 3},
          {deg: -180, orientation: 3},
          {deg: 270, orientation: 8},
          {deg: -90, orientation: 8},
          //later : permutations and combinations of these can enable flip
        ]

        const orientationToSet = degToOrientationValueMap.find(
          d => d.deg === (imageRotate % 360) //so that we bring all numbers within the range of -360 & 360
        ).orientation;

      // set proper canvas dimensions before transform & export
      if (orientationToSet >= 5 && orientationToSet <= 8) {
        canvas.width = height;
        canvas.height = width;
      } else {
        canvas.width = width;
        canvas.height = height;
      }

      // transform context before drawing image
      switch (orientationToSet) {
        case 2:
          ctx.transform(-1, 0, 0, 1, width, 0);
          break;
        case 3:
          ctx.transform(-1, 0, 0, -1, width, height);
          break;
        case 4:
          ctx.transform(1, 0, 0, -1, 0, height);
          break;
        case 5:
          ctx.transform(0, 1, 1, 0, 0, 0);
          break;
        case 6:
          ctx.transform(0, 1, -1, 0, height, 0);
          break;
        case 7:
          ctx.transform(0, -1, -1, 0, height, width);
          break;
        case 8:
          ctx.transform(0, -1, 1, 0, 0, width);
          break;
        default:
          break;
      }

      // draw image
      ctx.drawImage(img, 0, 0);

      // export base64
      callback({
        reorientedUrl: canvas.toDataURL(),
        imageWidth: canvas.width,
        imageHeight: canvas.height
      });
    };
    
  }